import React, { Component } from 'react'
import { v1 } from 'uuid';
import hocWithBaseElementWrap from '@utils/hocWithBaseElementWrap';
import { getMscByDomainKey } from 'ynf-core-engine/request';
import { ENV_RENDER_DESIGNER } from '@utils/constants'
import { observer } from "mobx-react";
import CommonUpload from './CommonUpload'
import { useState, useEffect } from 'react';
import FilesHandle from "./FilesHandle";
import { reaction } from 'mobx'

const Index = props => {
  const {
    alias,
    value,
    pageStore,
    // filesHandle,
    store,
    domainKey
  } = props;
  let objectName = props.objectName || props.defaultObjectName || domainKey || getMscByDomainKey?.(pageStore?.query?.domainKey) || pageStore?.query?.domainKey || 'developplatform';
  if (!domainKey && objectName === 'developplatform' && pageStore?.query?.domainKey === 'developplatform') {
    objectName = 'iuap-yonbuilder-runtime'
  }
  const authId = pageStore?.query?.serviceCode || "ybbase";
  const randomId = v1();
  const uploadFileId = props.uploadFileId || `yb-upload-${alias}-${value || randomId}`;
  const rootStore = pageStore?.rootStore;
  const filesHandle = rootStore?.controlStore.getStore('filesHandle') || new FilesHandle(pageStore)
  rootStore?.controlStore.registerStore('filesHandle', filesHandle)
  // const [tempObjectId, setTempObjectId] = useState();
  const queryFileInfo = (obj) => {
    if (obj?.objectId) {
      filesHandle?.setFileObj?.(obj);
    }
  }

  const afterDelete = (id) => {
    filesHandle?.setDeleteFiles?.(id);
  }

  const afterComponentLoad = () => {
    if (typeof props.store === 'string' && filesHandle) {
      const tableName = props.store;
      filesHandle.batchFilesTableName = tableName
    }
  }
  const list = filesHandle.getAllFiles() || {};
  const key = `${value}_${objectName}`;
  const [listData, setListData] = useState(list?.[key] || []);
  const [isCopy, setIsCopy] = useState(filesHandle?.copyFile);
  useEffect(() => {
    if (filesHandle?.queryFilesTimes) {
      const listData = filesHandle.getAllFiles();
      const key = `${value}_${objectName}`;
      setListData(listData?.[key] || []);
    }
  }, [filesHandle?.queryFilesTimes])

  useEffect(() => {
    if (filesHandle?.copyFile) {
      const copyFilelist = filesHandle.copyFilelist;
      (copyFilelist || []).forEach(item => {
        const { targetObjectId } = item;
        if (targetObjectId === value) {
          setIsCopy(filesHandle?.copyFile);
        }
      })
    }
  }, [filesHandle?.copyFile])


  /***
   * 什么时候不请求 什么时候请求
   * 暂时使用是不是来自table判断
   * 暂时注释---
  */
  let isBatch = false;
  let mode;
  let tableStore;
  if (typeof props.store === 'string') {
    isBatch = pageStore?.rootStore?.get(props.store)?.storeType === 'TableStore'
    tableStore = pageStore?.rootStore?.get(props.store)
  } else {
    isBatch = props?.store?.storeType === 'TableStore';
    tableStore = props.store;
  }
  if (isBatch) {
    mode = tableStore?.uiState;
  }
  useEffect(() => {
    const name = tableStore?.alias
    if (isBatch && !filesHandle?.batchFilesTableName.includes(name)) {
      // 这里未来会有问题，如果组件只渲染可视区的
      filesHandle?.initTableEvents({ name });
    }
  }, [])
  // 当store的uistate发生变化
  reaction(() => tableStore?.uiState, () => {
    filesHandle?.clearDeleteFiles?.();
    if (filesHandle) {
      filesHandle.copyFile = ''
    }
  })

  const showType = props.showType;
  // if (isBatch && showType === undefined) {
  //   showType = '2'
  // }
  // 设置值
  // 取值
  let noTemporaryValue = false; // 不是临时值 是临时值
  if (!filesHandle) {
    noTemporaryValue = true;
    isBatch = false;
  }

  const batchFileUploadCallBack = (key, list) => {
    filesHandle?.pushBatchFilesInFileStore?.(key, list);
  }

  // 上传后
  const onFileUploadCallBack = ({
    fileJson,
  }) => {
    fileJson.objectName = objectName;
    props?.onFileUploadCallBack?.(fileJson);
    if (!noTemporaryValue) {
      filesHandle?.pushFilesInFileStore?.(fileJson);
    }
  }
  // 删除后
  const onFileDeleteCallBack = ({
    fid,
    fileJson,
    fileCount
  }) => {
    if (fileCount === 0) {
      setListData([]);
    }
    fileJson.objectName = objectName;
    props.onFileDeleteCallBack?.({ fid, fileJson });
    if (!noTemporaryValue) {
      filesHandle?.deleteFilesInFileStore?.(fileJson, fid);
    }
  }

  const obj = {}
  if (props.nid) {
    obj.key = new Date().getTime()
  }
  return <CommonUpload
    {...obj}
    {...props}
    mode={mode}
    showType={showType}
    noTemporaryValue={noTemporaryValue}
    uploadInBrowse={props.uploadInBrowse || false}
    isBatch={isBatch}
    listData={props.value && listData || []}
    isCopy={isCopy}
    objectName={objectName}
    authId={authId}
    uploadFileId={uploadFileId}
    afterDelete={afterDelete}
    queryFileInfo={queryFileInfo}
    isDesigner={props.renderEnv === ENV_RENDER_DESIGNER}
    afterComponentLoad={afterComponentLoad}
    onFileUploadCallBack={onFileUploadCallBack}
    onFileDeleteCallBack={onFileDeleteCallBack}
    batchFileUploadCallBack={batchFileUploadCallBack}
  />
}
export default hocWithBaseElementWrap(observer(Index))
